import '../../resources/css/settings/SettingsMenu.scss';
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Nav } from 'react-bootstrap';
import { checkTableAuth } from '../../components/common/access-auth';

class SettingsMenu extends Component {

  selectMenu = (name) => {
    console.info('selectMenu...', name);

    const { history } = this.props;
    history.push(window.CONFIG.WEB_ROOT + "/settings/" + name);
  }

  renderMenuItem = (name, icon, text) => {
    return (
      <Nav.Link onSelect={() => this.selectMenu(name)} className="menu-item" eventKey={name}>
        <div className='area-item-content'>
          <span className={icon}></span>
          <label className='area-menu-item-text'>{text}</label>
        </div>
      </Nav.Link>
    );
  }

  render() {
    const { subPage, accountRole, roleTableAuth, systemVerInfo/*, systemInfo*/ } = this.props;
    
    // const navSiteAndGroup = this.renderMenuItem('siteAndGroup', 'icon-menu icon-model-settings', 'Site and Group Settings');
    // const navGuestPortal = this.renderMenuItem('guestPortal', 'icon-menu icon-guest-portal-settings', 'Guest Portal Settings');
    let navAccountRole = (<div className='area-account-and-role'></div>);
    if (checkTableAuth('onlyAdmin', accountRole, roleTableAuth, 2)) {
      navAccountRole = (
        <div className="area-menu-item">
          {this.renderMenuItem('accounts', 'icon-menu icon-account-role-settings', 'Accounts')}
        </div>
      );
    }

    const navNotification = this.renderMenuItem('notification', 'icon-menu icon-notification-settings', 'Notification Settings');
    const navFloorPlan = this.renderMenuItem('floorplan', 'icon-menu icon-model-settings', 'Floor Plan Settings');
    // const navNetwork = this.renderMenuItem('network', 'icon-menu icon-network-settings', 'Network Settings');
    // const navAbout = this.renderMenuItem('about', 'icon-menu icon-about-settings', 'About');
    // const navWiFi = this.renderMenuItem('wifi', 'icon-menu icon-wifi-settings', 'Wi-Fi Clusters');
    // const navAdvance = this.renderMenuItem('advance', 'icon-menu icon-btn-view-all-n', 'Advance');
    // const navNetworkContent = systemInfo === 'MX100' ? (
    //   <div className="area-menu-item">
    //     {navNetwork}
    //   </div>
    // ) : (<div></div>);

    return (
      <div className='area-settings-navigation-header'>
        <Nav defaultActiveKey={subPage} activeKey={subPage} variant="main-menu" className="main-menu flex-column">
          <div className="area-menu-item-option">
            {/*<div className="area-menu-item">*/}
            {/*  {navSiteAndGroup}*/}
            {/*</div>*/}
            {/*<div className="area-menu-item">*/}
            {/*  {navGuestPortal}*/}
            {/*</div>*/}
            {navAccountRole}
            <div className="area-menu-item">
              {navNotification}
            </div>
            <div className="area-menu-item">
              {navFloorPlan}
            </div>
            {/*{navNetworkContent}*/}
            {/*<div className="area-menu-item">*/}
            {/*  {navWiFi}*/}
            {/*</div>*/}
            {/*<div className="area-menu-item">*/}
            {/*  {navAdvance}*/}
            {/*</div>*/}
            {/*<div className="area-menu-item">*/}
            {/*  {navAbout}*/}
            {/*</div>        */}
            <div className="area-menu-item">
              <div className='menu-version'>
                {
                  systemVerInfo ? <span>HeatMAP v{systemVerInfo[0].parameterValue}</span> : null
                }
              </div>
            </div>
          </div>
        </Nav>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { subPage } = ownProps.match.params;
  const systemInfo = state.settingsReducers.systemInfo;
  const ret = {
    accountRole: state.loginReducers.accountRole,
    roleTableAuth: state.loginReducers.roleTableAuth,
    subPage: subPage,
    systemInfo: state.settingsReducers.systemInfo?.find(({ parameterKey }) => parameterKey === 'system.model.name').parameterValue
  }
  if (systemInfo) {
    ret.systemVerInfo = systemInfo.filter(info => info.parameterKey === 'system.version')
  }
  return ret;
}

export default withRouter(connect(
  mapStateToProps,
  {}
)(SettingsMenu))